import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { Button } from '~/components/ui/Button';
import * as Tooltip from '~/components/ui/Tooltip';
import { menuStore, SettingsPage } from '~/lib/stores/menu';
import { featurePreviewsStore } from '~/lib/stores/settings';

export const FeaturePreviews = memo(() => {
  const featurePreviews = useStore(featurePreviewsStore);

  const enabledFeaturePreviewCount = Object.values(featurePreviews ?? {}).filter(Boolean).length;

  return (
    enabledFeaturePreviewCount > 0 && (
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => {
                menuStore.openDialog({ type: 'settings', initialPage: SettingsPage.FeaturePreviews });
              }}
              startIcon="i-ph:flask-duotone"
              className="text-bolt-ds-textTertiary"
            >
              {String(enabledFeaturePreviewCount)}
            </Button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content side="bottom" avoidCollisions collisionPadding={10} sideOffset={6}>
              {enabledFeaturePreviewCount} experimental feature{enabledFeaturePreviewCount > 1 ? 's' : ''} enabled
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    )
  );
});
